import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Query } from '@web/constants/query';
import axios from 'axios';

type RefreshDownloadParams = {
  originalRequestId: string;
  excludePreviouslyDownloadedRecords: boolean;
  email: string;
};

const useRefreshDownload = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: RefreshDownloadParams) => {
      const response = await axios.post(
        `${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/download/requested/refresh`,
        params,
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [Query.SupabaseKeys.downloads] });
    },
  });
};

export { useRefreshDownload };
